import React, { useRef } from 'react';
import { Form, SimpleItem, ButtonItem, ButtonOptions, RequiredRule, Label } from 'devextreme-react/form';

const TestForm = () => {
  const formRef = useRef<Form>(null);

  const handleSubmit = () => {
    const formInstance = formRef.current?.instance;

    // Validar todo el formulario
    const validationResult = formInstance?.validate();

    if (validationResult?.isValid) {
      alert('Formulario válido. ¡Enviando datos!');
    } else {
      console.warn('Errores de validación:', validationResult?.brokenRules);
    }
  };

  return (
    <div style={{ margin: '50px auto', maxWidth: '500px' }}>
      <h2>Formulario de Prueba</h2>
      <Form ref={formRef} formData={{}} showValidationSummary={true} showRequiredMark={true}>
        {/* Campo 1: Texto requerido */}
        <SimpleItem dataField="nombre" editorType="dxTextBox">
          <RequiredRule message="El nombre es requerido" />
          <Label text="Nombre" />
        </SimpleItem>

        {/* Campo 2: Email con validación */}
        <SimpleItem dataField="email" editorType="dxTextBox" editorOptions={{ placeholder: 'example@email.com' }}>
          <RequiredRule message="El correo electrónico es requerido" />
          <Label text="Email" />
        </SimpleItem>

        {/* Campo 3: Fecha */}
        <SimpleItem dataField="fechaNacimiento" editorType="dxDateBox" editorOptions={{ placeholder: 'dd/MM/yyyy' }}>
          <RequiredRule message="La fecha de nacimiento es requerida" />
          <Label text="Fecha de Nacimiento" />
        </SimpleItem>

        {/* Botón de envío */}
        <ButtonItem>
          <ButtonOptions
            text="Guardar"
            type="default"
            onClick={handleSubmit}
          />
        </ButtonItem>
      </Form>
    </div>
  );
};

export default TestForm;
